import * as React from "react";
import { Link } from "react-router-dom";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";

/**
 * A DaisyUI-styled card component that displays exercise information.
 *
 * @component
 * @param {Object} props
 * @param {string} props.image - URL of the image
 * @param {string} props.title - Title text
 * @param {string} props.description - Description text
 * @param {string} [props.link] - Optional link URL
 * @param {boolean} [props.isPinned] - Whether the exercise is pinned
 * @param {function} [props.onPinToggle] - Callback when pin is toggled
 * @param {string} [props.category] - Category label for the exercise
 */
function ExerciseCard({ image, title, description, link, isPinned = false, onPinToggle, category }) {
  return (
    <div className="card card-bordered catalog-card">
      {/* Pin button */}
      <button
        className={`catalog-card-pin ${isPinned ? "catalog-card-pin-active" : ""}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onPinToggle();
        }}
        aria-label={isPinned ? "Unpin exercise" : "Pin exercise"}
      >
        {isPinned ? (
          <PushPinIcon style={{ fontSize: 18 }} />
        ) : (
          <PushPinOutlinedIcon style={{ fontSize: 18 }} />
        )}
      </button>

      {/* Card content as link */}
      {link ? (
        <Link to={link} className="catalog-card-link">
          <figure className="catalog-card-figure">
            <img src={image} alt={title} className="catalog-card-image" loading="lazy" />
          </figure>
          <div className="card-body catalog-card-body">
            <div className="catalog-card-meta">
              {category && <span className="badge badge-ghost badge-sm">{category}</span>}
            </div>
            <h2 className="card-title catalog-card-title">{title}</h2>
            <p className="catalog-card-desc">{description}</p>
          </div>
        </Link>
      ) : (
        <div>
          <figure className="catalog-card-figure">
            <img src={image} alt={title} className="catalog-card-image" loading="lazy" />
          </figure>
          <div className="card-body catalog-card-body">
            <div className="catalog-card-meta">
              {category && <span className="badge badge-ghost badge-sm">{category}</span>}
            </div>
            <h2 className="card-title catalog-card-title">{title}</h2>
            <p className="catalog-card-desc">{description}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default ExerciseCard;
